// The icon open in the detail panel (one per page, shared by every category grid)
const iconDetail = function reducer(state = { icon: null }, action) {
	switch (action.type) {
		case 'OPEN_ICON_DETAIL': {
			return { ...state, icon: action.payload }
		}
		case 'CLOSE_ICON_DETAIL': {
			return { ...state, icon: null }
		}
	}
	return state
}
export default iconDetail
